import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Heading from "../../components/Heading";
import SetListForm from "../../components/setList/SetListForm";
import { Grid, Paper } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

@inject("songListStore", "setListStore", "profileStore")
@observer
class SetListNew extends Component {
    render() {
        const { currentProfile } = this.props.profileStore;

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Link to="/musician/setlist" style={{ display: "inline-flex", alignItems: "center", color: "#FE0D9D", textDecoration: "none", marginBottom: 16 }}>
                        <ArrowBackIcon style={{ fontSize: 18, marginRight: 6 }} />
                        Back to all Set Lists
                    </Link>
                    <Heading title={"Set List"} />
                    <Paper style={{ padding: 16 }}>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                {currentProfile && <SetListForm id={this.props.match.params.id} type="musician" profileId={currentProfile.id} />}
                            </Grid>
                        </Grid>
                    </Paper>
                </MainContainer>
            </main>
        );
    }
}

export default SetListNew;
